import { updatesItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-timer-flash-line text-sm"></i>
            实时快讯
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新爆料快讯</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">24小时滚动更新的娱乐圈最新动态与爆料消息，不放过每一个瓜。</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesItems.map((item, index) => (
            <div
              key={item.id}
              className="flex items-start gap-4 py-4 border-b border-background-200/50 last:border-b-0 group cursor-pointer hover:bg-background-100/50 -mx-3 px-3 rounded-md transition-colors duration-200"
            >
              <div className="flex-shrink-0 w-16 text-right">
                <span className="text-xs text-foreground-400 font-mono">{item.time}</span>
              </div>
              <div className="flex-shrink-0">
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-bold whitespace-nowrap ${
                  item.tag === '爆料' || item.tag === '首发'
                    ? 'bg-primary-100 text-primary-700'
                    : item.tag === '独家'
                    ? 'bg-accent-100 text-accent-700'
                    : item.tag === '热议'
                    ? 'bg-primary-100/80 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              </div>
              <p className="flex-1 text-sm md:text-base text-foreground-700 leading-relaxed group-hover:text-foreground-900 transition-colors duration-200">
                {item.content}
              </p>
              {index === 0 && (
                <span className="flex-shrink-0 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">NEW</span>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#updates" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            查看更多快讯
            <i className="ri-arrow-down-s-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}